var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"go_top",class:_vm.isShow?'show_btn':_vm.isFirstLoad?'':'hide_btn',style:({'background-color':_vm.color}),on:{"click":_vm.goTop}},[_c('svg-icon',{attrs:{"svg-name":"select-up","width":"15px","height":"10px"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }